<template>
    <div class="section-container w-100">
        <SectionTitle title=" Max Value Comparisons" />

        <MissingDataText v-if="!hasData" message="Max Value Comparisons Unavailable" />
        <div v-else>
            <div class="d-flex justify-content-center mx-auto">
                <RadioButton :id="'kpi-radio-group'" :modal="selected" :options="options" :label="''"
                    :name="'kpi-radio-options'" @update-modal="selected = $event" :task="getKPIData" />
            </div>
            <KpiComparisonTable v-if="hasData" :kpiValues="maxValues" :kpiComparison="comparisonValues"
                :valueLabel="labels[selected]" :maxValueDate="maxValueDate" kpiPrefix="Max" />
        </div>
    </div>
</template>

<script>
import SectionTitle from "@/components/SectionTitle.vue";
import KpiComparisonTable from "./KpiComparisonTable";

export default {
    props: {
        data: Object,
    },
    components: {
        KpiComparisonTable,
        SectionTitle
    },
    data() {
        return {
            hasData: false,
            selected: "maxComparisonValues",
            options: [
                { text: 'Max', value: 'maxComparisonValues' },
                { text: 'Average', value: 'avgComparisonValues' },
                { text: 'Target', value: 'targetValues' },
            ],
            maxValues: null,
            comparisonValues: null,
            labels: {
                maxComparisonValues: "match max",
                avgComparisonValues: "match average",
                targetValues: "rehab target"
            },
            maxValueDate: null
        };
    },
    methods: {
        getKPIData() {
            this.hasData = Object.values(this.data.maxValues).every(value => value !== null);
            if (this.hasData) {
                this.maxValues = this.data.maxValues;
                this.comparisonValues = this.data[this.selected];
                this.maxValueDate = this.data.maxValuesDate;
            }
        }
    },
    watch: {
        data: {
            handler() {
                this.getKPIData();
            },
            deep: true
        }
    },
    async mounted() {
        this.getKPIData();
    },
};
</script>